import React from "react";

import { CheckIcon } from "lucide-react";
import type { PlayerTrack } from "@/types/player.type";
import ResponsiveDialog from "@/components/ResponsiveDialog";
import { cn } from "@/lib/utils";

interface PlayerPreferenceModalProps {
  mediaList: Array<PlayerTrack>;
  activePlayerPreferenceIndex: number | null;
  title: string;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  onPlayerPreferenceChange: (index: number) => void;
  /** Passed through to `ResponsiveDialog` (the fullscreen player). */
  container?: HTMLElement | null;
}

const PlayerPreferenceItem: React.FC<{
  language: string;
  isActive: boolean;
  onClick: () => void;
}> = ({ language, isActive, onClick }) => {
  return (
    <li>
      <button
        className={cn(
          "hover:bg-neutral-60 flex h-14 w-full items-center gap-2 rounded-sm px-4 text-left text-lg font-bold",
          isActive && "bg-primary hover:bg-primary",
        )}
        onClick={onClick}
      >
        <p className="grow">{language}</p>
        {isActive && <CheckIcon className="size-5" />}
      </button>
    </li>
  );
};

const PlayerPreferenceModal: React.FC<PlayerPreferenceModalProps> = ({
  mediaList,
  activePlayerPreferenceIndex,
  title,
  open,
  onOpenChange,
  onPlayerPreferenceChange,
  container,
}) => {
  return (
    <ResponsiveDialog
      title={title}
      open={open}
      onOpenChange={onOpenChange}
      container={container}
      className="flex flex-col gap-4"
    >
      <ul className="overflow-y-auto px-4">
        {mediaList.map((media) => (
          <PlayerPreferenceItem
            key={media.id}
            language={media.name}
            isActive={media.id === activePlayerPreferenceIndex}
            onClick={() => {
              onPlayerPreferenceChange(media.id);
              onOpenChange?.(false);
            }}
          />
        ))}
      </ul>
    </ResponsiveDialog>
  );
};

export default PlayerPreferenceModal;
